module.exports = __webpack_public_path__ + "media/images/country_flags/je-2bc744e122ecccb4379d18c623ca7a43.png";